<template>
  <NuxtLayout
    name="main-view"
    :headline="$t('dbc-btn-text-change-mobile-phone')"
  >
    <Card :pt="formCardPassThrough">
      <template #content>
        <FormKit
          :actions="false"
          type="form"
          form-class="rounded-lg"
          @submit="updatePhone"
          #default="{ disabled, state: { valid } }"
          :aria-invalid="errorMessage"
        >
          <DbcBanner
            v-if="errorMessage"
            id="errorBanner"
            :severity="'warn'"
            :message="errorMessage"
          />

          <FormKit
            id="tel"
            type="dbc-tel"
            :label-input="$t('dbc-label-mobile-phone')"
            name="tel"
            :options="countries ?? ['DE']"
            placeholder-select="DE"
            :placeholder-input="`${$t('dbc-placeholder-mobile-phone')}`"
            validation="required"
            :label-select="$t('dbc-label-country')"
            :validation-messages="{
              rule_tel: `${$t('dbc-label-mobile-phone')} ${$t(
                'dbc-error-invalid'
              )}`,
            }"
          />

          <div class="flex flex-col gap-2xs">
            <FormKit
              type="submit"
              id="submit"
              :label="
                !valid
                  ? $t('dbc-text-fill-in-mandatory-fields')
                  : $t('dbc-btn-text-change-mobile-phone')
              "
              :disabled="disabled || !valid || isLoading"
              :loading="isLoading"
              :aria-label="
                !valid
                  ? $t('dbc-text-fill-in-mandatory-fields')
                  : !isLoading
                  ? $t('dbc-btn-text-change-mobile-phone')
                  : $t('dbc-text-loading')
              "
            />
            <FormKit
              type="button"
              id="abort"
              @click="
                router.push({
                  path: usePagePath('data'),
                })
              "
              :label="$t('dbc-btn-abort')"
            />
          </div>
        </FormKit>
      </template>
    </Card>
  </NuxtLayout>
</template>

<script setup lang="ts">
import type { ParsedPhoneNumber } from 'awesome-phonenumber'
import { useCustomerStore } from '../../../../../stores/customer'

const router = useRouter()

const customerStore = useCustomerStore()

const { t } = useI18n()

const errorMessage = ref('')
const isLoading = ref(false)
const countries = await useFetchCountries()

async function updatePhone(formData: {
  tel: { parsedPhoneNumber: ParsedPhoneNumber }
}) {
  isLoading.value = true
  const response = await fetchUpdateData({
    mobile: formData.tel.parsedPhoneNumber?.number?.e164,
  })
  if (response.status === 200) {
    await customerStore.getData()

    router.push({
      path: usePagePath('data'),
      query: { update: 'mobile-phone' },
    })
  } else if (
    response.data?.errorAttributes &&
    response.data.errorAttributes[0].message
  ) {
    errorMessage.value = response.data.errorAttributes[0].message
  } else {
    errorMessage.value = t('dbc-error-server-issues')
  }
  isLoading.value = false
}
</script>
